import styled from "styled-components";
import { Field } from "formik";

export const Container = styled.div`
  direction: rtl;
  float: left;
  position: relative;
  &:after {
    content: "<>";
    font: 17px "Consolas", monospace;
    position: absolute;
    color: #629ee8;
    right: 11px;
    bottom: 0;
    transform: translate(-40%, -40%);
    padding: 0 0 2px;

    pointer-events: none;
  }
  @media (max-width: 360px) {
    ::after {
      bottom: 10%;
      right: 0;
    }
  }
`;

export const StyledField = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-word-break: normal;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  color: ${(props) => props.titleColor || "#27548c"};
  background-color: transparent;
  border: 1px solid ${(props) => props.borderColor || "#75a8e8"};
  appearance: none;
  cursor: pointer;
  display: block;
  padding: 0px 50px;
  font-size: 15px;
  font-style: normal;
  line-height: 28px;
  word-break: normal;
  border-radius: 10px;
  outline: none;
  @media (max-width: 360px) {
    width: ${(props) => props.width360 || "300px"};
  }
  /* ::-ms-expand {
    display: none;
  } */

  option {
    color: ${(props) => props.optionsColor || "#27548c"};
    cursor: pointer;
  }
`;
